import type { NextPage } from 'next'
import { useRouter } from 'next/router'
import { useEffect, useRef, useState } from 'react'
import menuItems, { IMenuItem } from '../menus'
import style from './Banner.module.css'
import { getMenuItems } from './util'

interface IProps {
}

const Component: NextPage<IProps> = ({}) => {
  const Router = useRouter()
  const [isActiveMainMenu, setIsActiveMainMenu] = useState<boolean>(false)
  const [isActiveSubMenu, setIsActiveSubMenu] = useState<boolean>(false)
  const [selectedMainItem, setSelectedMainItem] = useState<IMenuItem | undefined>(undefined)
  const [selectedSubItem, setSelectedSubItem] = useState<IMenuItem | undefined>(undefined)
  const [selectedSubItems, setSelectedSubItems] = useState<IMenuItem[] | undefined>(undefined)

  useEffect(() => {
    const result = getMenuItems(Router);
    setIsActiveMainMenu(result.isActiveMainMenu);
    setIsActiveSubMenu(result.isActiveSubMenu);
    setSelectedMainItem(result.selectedMainItem);
    setSelectedSubItem(result.selectedSubItem);
    setSelectedSubItems(result.selectedSubItems);
  }, [Router])

  return (
    <div className={`${style.bannerWrap} min-w-[1200px] flex flex-col justify-center items-center`}>
      <div>
        <h2 className="text-[40px] font-medium tracking-[-3px] text-center leading-[130%]">
          {isActiveSubMenu && selectedSubItem
            ? selectedSubItem.title
            : isActiveMainMenu && selectedMainItem ? selectedMainItem.title : ''
          }
        </h2>
      </div>
    </div>
  )
}

export default Component
